import React from 'react'
import { Link } from 'gatsby'
import styled from '@emotion/styled'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import { mq } from '@/utils/helpers'
import { mobile } from '@/utils/media'
import Typography from '@/components/common/Typography'
import GhostButton from '@/components/common/GhostButton'

const CompanyLead = props => (
  <Root>
    <Root_Content theme={props.theme}>
      <Title variant="h2">ウィザードってどんな会社？</Title>
      <Body variant="body1">受託開発会社なのにお客様と直接の取引が多い。自社所有の本社オフィス、長野には自社保養所のある、業界では少し変わった会社です。</Body>
      <Button to="/recruit/company/" component={Link}>さらに詳しく</Button>
    </Root_Content>
  </Root>
)

export default ThemeConsumer(CompanyLead)

const Root = styled.div`
`

const Root_Content = styled.div`
  padding: 64px 0;
  background: ${props => props.theme.scale[800]};
  text-align: center;
`

const Title = styled(Typography)`
  text-align: center;
`

const Body = styled(Typography)`
  margin: 24px auto 0;
  text-align: center;
  max-width: 624px;
  @media ${mq.and(mobile)} {
    padding: 0 16px;
  }
`

const Button = styled(GhostButton)`
  margin-top: 40px;
  width: 180px;
  @media ${mq.and(mobile)} {
    margin-top: 24px;
  }
`
